import React, {useEffect, useState} from 'react'
// Actions
import { Base_API } from '../../_actions/matcher';
import { NhealthAction } from '../../_actions/action.api'
// Styles
import './cfod.style.css'
// Swal
import Swal from "sweetalert2";
import moment from 'moment-timezone'
import { useParams } from 'react-router-dom'
// Icons
import GrayCross from '../../assets/images/icons/gray-cross.png'
import { DecryptedOBJ, DecryptedText, EncryptedOBJ, EncryptedText } from '../../utils/Encryption';


function Confirm_Order_NhServices(props) {
    const {ref} = useParams(); 

    const [contactInform, setContactInform] = useState(
        [
            {
                id: 1,
                title: 'ชื่อ / Name',
                input_type: 'text',
                input_name: 'fname',
                place_holder: 'กรอกชื่อ / Name ',
                value: '-'
            },
            {
                id: 2,
                title: 'นามสกุล / Surname',
                input_type: 'text',
                input_name: 'lname',
                place_holder: 'กรอกนามสกุล / Surname',
                value: '-'
            },
            {
                id: 3,
                title: 'วันเดือนปีเกิด / Date of Birth',
                input_type: 'date',
                input_name: 'dateofbirth',
                place_holder: 'dd/mm/yyyy',
                value: '-'
            },
            {
                id: 4,
                title: 'เบอร์ติดต่อ / Contact Number',
                input_type: 'tel',
                input_name: 'tel',
                place_holder: 'กรอกเบอร์ติดต่อ / Contact Number',
                value: '-'
            },
            {
                id: 5,
                title: 'E-mail',
                input_type: 'email',
                input_name: 'email',
                place_holder: 'กรอก E-mail',
                value: '-'
            },
        ]
    );
    const [appointInform, setAppointInform] = useState({
        appointment_date: '',
        deli_address: '',
        remark: '',
        time: ''
    });
    const [deliveryInform, setDeliveryInform] = useState({
        "delivery_address": "",
        "province": "",
        "amphoe": "",
        "district": "",
        "zipcode": "",
        "want_tax": false,
        "branch_code": "",
        "branch_question": "",
        "tax_id": "",
        "tax_type": "",
        "tax_invoice_name": "",
        "tax_phone": "",
        "email_tax": "",
        "address_tax": "",
        "province_tax": "",
        "amphoe_tax": "",
        "district_tax": "",
        "zipcode_tax": "",
        "latitude": 0.0,
        "longtitude": 0.0,
        "headOfficeStatus": true
    })
    const [loading, setLoading] = useState(true);
    const [totalPrice, setTotalPrice] = useState(0);
    const [cartList, setCartList] = useState(null);
    const [campaignData, setCampaignData] = useState(null);
    const [memberData, setMemberData] = useState(null);
    const [isAppoint, setIsAppoint] = useState(false);
    const [isMember, setIsMember] = useState(false); // true, false
    const [paymentMethod, setPaymentMethod] = useState('');
    const [btnRemoveCoupon, setBtnRemoveCoupon] = useState(false);
    const [pageDetail, setPageDetail] = useState({
        totalPrice: '',
        discountText: '',
        discountPrice: '',
        netPrice: '',
        couponName: '-',
        couponPrice: '0'
    });

    useEffect(() => {
        dataInit();
    },[])

    // Data Init
    const dataInit = async() => {
        await checkCameFrom();
        await getContactInformData();
        await getTotalPrice();
        let campaignData = await campaignInit();
        let mem_id = await checkUserInit();
        let calCartData = await calCartInit(campaignData,mem_id);
        await checkIsAppoint(calCartData); 
        handlerLoader('inactive');
    }

    const checkCameFrom = () => {
        return new Promise(async resolve => {
            let flag = localStorage.getItem('frompage-editcontactinform');
            
            if(!!flag)
            {
                localStorage.removeItem('frompage-editcontactinform');
                window.location.reload();
            }else
            {
                resolve();
            }
        })
    }

    const checkIsAppoint = (cartData) => {
        return new Promise(async resolve => {
            // console.log('Cart Data: ', cartData);
            if(cartData.length > 0)
            {
                let appointList = String([...new Set(cartData.map(item => item.isAppoint))]);
                if(appointList.indexOf('true') < 0)
                {
                    setIsAppoint(false);
                    localStorage.setItem('isAppoint', false);
                }else
                {
                    setIsAppoint(true); 
                    localStorage.setItem('isAppoint', true);
                }
                resolve();
            }
        })
    }

    const handlerLoader = (status) => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const campaignInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetCampaignProductsOnline().then(data => {
                // console.log('Campaign: ', data);
                setCampaignData(data.campaign);
                handlerAppointPeriod(data.campaign); 
                resolve(data.campaign);
            })
        })
    }

    const handlerAppointPeriod = (data) => {
        localStorage.setItem('appoint_period', EncryptedText(`${moment(data.appstartDate).format('YYYY/MM/DD')}||${moment(data.appendDate).format('YYYY/MM/DD')}`));
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    if(res.isSuccess === true)
                    {
                        setIsMember(true);
                        setMemberData(res.member);
                        resolve(res.member.membercode);
                    }else
                    {
                        setIsMember(false);
                        resolve(line_profile.user_id);
                    }
                })
            }else
            {
                window.location.href = `${Base_API.pathWeb}/n-health/nh-services/${ref}`;
            }
        })
    }

    const calCartInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            let couponSelected = !!localStorage.getItem('couponselected') ? DecryptedOBJ(localStorage.getItem('couponselected')) : null;
            let useCoupon = !!couponSelected ? couponSelected.id : 0;

            NhealthAction.CalCart(campaignData.id, useCoupon, membercode)
            .then(res => {
                if(!!couponSelected) setBtnRemoveCoupon(true);

                let netPrice = Number(res.netPrice).toLocaleString('th', {minimumFractionDigits: 2});

                // console.log('Coupon Selected: ', couponSelected);
                // console.log('cal cart data: ', res);

                setCartList(res.cart);
                setPageDetail({
                    ...pageDetail,
                    totalPrice: Number(res.totalPrice).toLocaleString('th', {minimumFractionDigits: 2}),
                    discountText: returnDiscountText(res),
                    discountPrice: Number(res.discountPrice).toLocaleString('th', {minimumFractionDigits: 2}),
                    netPrice: netPrice,
                    couponName: !!couponSelected ? couponSelected.title : '-',
                    couponPrice: Number(res.discountCoupon).toLocaleString('th', {minimumFractionDigits: 2})
                });
                localStorage.setItem('cartList', EncryptedOBJ(res.cart));
                localStorage.setItem('netprice', EncryptedText(netPrice));
                resolve(res.cart);
            })
        })
    }

    const returnDiscountText = (data) => {
        return 'ส่วนลด '+data.PromotionText;
        // if(data.isPromotion !== 0)
        // {
        //     return 'ส่วนลด '+data.PromotionText
        // }else
        // {
        //     return ''
        // }
    }

    const getContactInformData = () => {
        return new Promise(async resolve => {
            let contactInformData = !!localStorage.getItem('cfod-contact-inform') ? DecryptedOBJ(localStorage.getItem('cfod-contact-inform')) : null;

            // console.log(contactInformData);

            setContactInform(!!contactInformData ? contactInformData : contactInform);
            resolve();
        })
    }

    const getTotalPrice = async() => {
        return new Promise(async resolve => {
            let ttp = !!localStorage.getItem('total_price') ? DecryptedText(localStorage.getItem('total_price')) : 0;
            setTotalPrice(ttp);
            resolve();
        });
    }
    const handleEditInform = (type) => {
        switch(type) 
        {
            case 'contact':
                window.location.href = `${Base_API.pathWeb}/n-health/order/edit-contact-inform/services/${ref}`;
                break;
            case 'appoint':
                window.location.href = `${Base_API.pathWeb}/n-health/form/appointment/services/${ref}`;
                break;
            case 'delivery':
                window.location.href = `${Base_API.pathWeb}/n-health/form/3/services/${ref}`;
                break;
            default: 
                return;
        }
    }

    const handleCheckMyCoupons = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/confirm-order/coupons/services/${ref}`;
    }

    const handleRemoveCouponSelected = () => {
        localStorage.removeItem('couponselected');
        window.location.reload();
    }

    const handlerPaymentMethod = (e) => {
        setPaymentMethod(e.target.value);
    }

    const handleSubmit = async() => {
        await validateOrder();
        if(isMember === true)
        {
            window.location.href = `${Base_API.pathWeb}/n-health/order/payment/nhservices/${ref}`
        }else
        {
            alertConfirmOrder('ท่านต้องการสมัครสมาชิกกับ N Health ก่อนหรือไม่?');
        }
    }

    const validateOrder = () => {
        return new Promise(async resolve => {
            let contactInformData = !!localStorage.getItem('cfod-contact-inform') ? DecryptedOBJ(localStorage.getItem('cfod-contact-inform')) : null;

            if(!!contactInformData)
            {
                if(paymentMethod === 'krungsri')
                {
                    resolve();
                }else
                {
                    showAlert('กรุณาเลือกช่องทางการชำระ');
                }
            }else
            {
                showAlert('กรุณาเพิ่มข้อมูลติดต่อ');
            }
        });
    }

    const showAlert = (msg) => {
        Swal.fire({
            title: "ผิดพลาด",
            text: msg,
            icon: 'error',
            confirmButtonText: 'ตกลง',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-1 right-gap',
                confirmButton: 'order-2',
                denyButton: 'order-3',
            }        
        })
    }

    const alertConfirmOrder = (msg) => {
        Swal.fire({
          text: msg,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "สมัครสมาชิก",
          cancelButtonText: "ข้ามไปก่อน",
        }).then((result) => {
          if (result.isConfirmed) {
            localStorage.setItem('cameFromConfirmOrder', `/n-health/order/payment/nhservices/${ref}`);
            window.location.href = `${Base_API.pathWeb}/n-health/form-card-register` 
          }else
          {
            window.location.href = `${Base_API.pathWeb}/n-health/order/payment/nhservices/${ref}`
          }
        });
    } 

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="cfod-container">
                {/* headtext */}
                <h1 className="header-text">
                    สรุปคำสั่งซื้อ
                </h1>
    
                {/* contact inform */}
                <div className="ct-inform">
                    {/* label wrap */}
                    <div className="label-wrap">
                        <p className="label t-bold ts-normal t-label">ข้อมูลติดต่อ</p>
                        <p
                            className="edit-ct-inform t-normal"
                            onClick={() => handleEditInform('contact')}
                        >
                            แก้ไขข้อมูล
                        </p>
                    </div>
                    {/* inform preview */}
                    <div className="ct-pv">
                        {/* item */}
                        <div className="item">
                            <p className="left">ชื่อผู้สั่งซื้อ</p>
                            <p className="right">{contactInform[0]["value"] === '-' ? '-' : `${contactInform[0]["value"]} ${contactInform[1]["value"]}`}</p>
                        </div>
                        <div className="item">
                            <p className="left">เบอร์ติดต่อ</p>
                            <p className="right">{contactInform[3]["value"]}</p>
                        </div>
                        <div className="item">
                            <p className="left">อีเมล</p>
                            <p className="right">{contactInform[4]["value"]}</p>
                        </div>
                    </div>

                    {/* Package Lists */}
                    <div className="pck-list">
                        {/* label */}
                        <p className="label ts-normal t-lowblue t-bold t-label">รายการแพ็กเกจ</p>
                        {/* card */}
                        <div className="pck-card">
                            {cartList !== null &&
                                cartList.map((item, i) => 
                                    <div 
                                        className="item"
                                        key={i}
                                    >
                                        <div className="left">
                                            <p className="pg-name t-normal ts-normal">
                                                {item.name_th}
                                            </p>
                                            <p className="price t-bold ts-notmal">
                                                ฿ {Number(item.totalPrice).toLocaleString('th', {minimumFractionDigits: 2})}<br/>
                                                x{item.totalAmount}
                                            </p>
                                        </div>
                                    </div> 
                                )
                            }
                        </div>
                    </div>
    
                    {/* Payment Methods */}
                    <div className="pm-mthd">
                        {/* label */}
                        <p className="label t-bold ts-normal t-lowblue t-label">ช่องทางการชำระ</p>
                        {/* card */}
                        <div className="card">
                            <div className="item">
                                <input 
                                    type="radio" id="kngth-pmmth" name="pm-mthd" value='krungsri'
                                    onChange={handlerPaymentMethod}
                                />
                                <label htmlFor="kngth-pmmth"><span className="t-normal">โอนผ่านบัญชี</span> <span className="t-bold">ธนาคารไทยพาณิชย์</span></label>
                            </div>
                        </div>
                    </div>
    
                    {/* Discount Coupon */}
                    <div className="dc-coupon">
                        {/* label */}
                        <p className="label t-bold ts-normal t-lowblue t-label">คูปองส่วนลด</p> 
                        {/* card */}
                        <div className="card">
                            <p className="cp-text t-normal ts-normal t-blue">
                                {pageDetail.couponName}
                                {/* displayed when coupon selected */}
                                {btnRemoveCoupon &&
                                    <img 
                                        className="rm-coup"
                                        src={GrayCross} 
                                        onClick={handleRemoveCouponSelected}
                                    />
                                }
                            </p>
                            <button 
                                type="button"
                                onClick={handleCheckMyCoupons}
                            >
                                ใช้คูปอง
                            </button>
                        </div>
                        {/* remark */}
                        <p className="remark t-normal t-red">
                            {/* ไม่สามารถใช้งานคูปองได้ <span className="t-decoration-underline">กรุณลองใหม่อีกครั้ง</span> */}
                        </p>
                    </div>
    
                    {/* List Summary */}
                    <div className="list-smmry">
                        {/* label */}
                        <p className="label t-bold ts-normal t-lowblue t-label">สรุปรายการ</p> 
                        {/* card */}
                        <div className="card">
                            {/* total price */}
                            <div className="ttp t-normal">
                                <p className="label">ราคารวม</p>
                                <p className="value">฿ {pageDetail.totalPrice}</p>
                            </div>
                            {/* discount price */}
                            <div className="dcp t-normal t-red">
                                <p className="label">{pageDetail.discountText}</p>
                                <p className="value">฿ -{pageDetail.discountPrice}</p>
                            </div>

                            {/* coupon & promotion code */}
                            {btnRemoveCoupon &&
                                <div className="cp-pmcode">
                                    <p className="label t-normal">คูปอง/โปรโมชั่นโค้ด</p>
                                    <div className="value t-normal">
                                        <p className="name">{pageDetail.couponName}</p>
                                        <p className="t-red">฿ -{pageDetail.couponPrice}</p>
                                    </div>
                                </div>
                            }

                        </div>
                    </div>
                </div>
    
                {/* Tab Confirm Order */}
                <div className="tab-cforder">
                    <div className="tt-wrap">
                        <h3 className="label">ยอดที่ต้องชำระ</h3>
                        <h3 className="value">฿ {pageDetail.netPrice}</h3>
                    </div>
                    <button 
                        className="btn-cforder"
                        onClick={handleSubmit}
                    >
                        ยืนยันการสั่งซื้อ
                    </button>
                </div>
            </div>
        )
    }
}

export default Confirm_Order_NhServices